import React, { useState, useRef } from 'react';
import { View, TextInput, StyleSheet, Text, TouchableOpacity, Dimensions } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ChannelFilterDropdown, FilterOption } from './ChannelFilterDropdown';

interface ChannelListHeaderProps {
    onSearch?: (text: string) => void;
    onFilterChange?: (filter: FilterOption) => void;
}

export const ChannelListHeader = ({ onSearch, onFilterChange }: ChannelListHeaderProps) => {
    const insets = useSafeAreaInsets();
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState<FilterOption>('All');
    const [dropdownAnchor, setDropdownAnchor] = useState({ top: 0, right: 0 });
    const filterButtonRef = useRef<View>(null);

    const handleFilterSelect = (filter: FilterOption) => {
        setSelectedFilter(filter);
        onFilterChange?.(filter);
    };

    const handleFilterPress = () => {
        filterButtonRef.current?.measure((_x, _y, width, height, pageX, pageY) => {
            const screenWidth = Dimensions.get('window').width;
            setDropdownAnchor({
                top: pageY + height + 4,
                right: screenWidth - pageX - width,
            });
            setDropdownVisible(true);
        });
    };

    return (
        <View style={[styles.container, { paddingTop: insets.top }]}>
            <View style={styles.headerTop}>
                <Text style={styles.title}>Chats</Text>
                <TouchableOpacity ref={filterButtonRef} onPress={handleFilterPress}>
                    <Ionicons name="filter" size={20} color="#11181C" />
                </TouchableOpacity>
            </View>
            <View style={styles.searchContainer}>
                <Ionicons name="search-outline" size={20} color="#9CA3AF" style={styles.searchIcon} />
                <TextInput
                    style={styles.searchInput}
                    placeholder="Search.."
                    placeholderTextColor="#9CA3AF"
                    onChangeText={onSearch}
                />
            </View>
            <ChannelFilterDropdown
                visible={dropdownVisible}
                onClose={() => setDropdownVisible(false)}
                selectedFilter={selectedFilter}
                onSelect={handleFilterSelect}
                anchor={dropdownAnchor}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingBottom: 12,
        backgroundColor: 'white',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: '#E5E5E5',
    },
    headerTop: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
        height: 44,
    },
    title: {
        fontSize: 17,
        fontWeight: '600',
        color: '#11181C',
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: '#E5E5E5',
        borderRadius: 8,
        paddingHorizontal: 12,
        height: 44,
    },
    searchIcon: {
        marginRight: 8,
    },
    searchInput: {
        flex: 1,
        fontSize: 16,
        color: '#11181C',
    },
});
